import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getFaqData } from '../../Redux/ActionCreater';
import Accordion from './Accordion';
import $ from "jquery"
import { Helmet } from 'react-helmet-async';
// import { Helmet } from 'react-helmet';

function Faq() {
    const [faq,setFaq]=useState();
    const [loading,setLoading]=useState(true);
    const [id,setId]=useState("");
    const dispatch = useDispatch();
    const [test,settest]=useState(true);

  const state = useSelector(
    (state) => (
       state.dataReducer
    ),
    shallowEqual
  );
    useEffect(() => {
        fetchData()
      }, []);

      const fetchData = async () => {
        let header={
          headers:{
          "X-Auth-Token":"12345"
        }};
        dispatch(getFaqData(header));
        
      };

      useEffect(() => {
        setFaq(state.faqData.data);
        setLoading(state.isLoading)
        }, [state])
        
  return (
    <>
    <Helmet>
          <title>{`CNC Machine :: FAQ`}</title>
          {/* <meta name="description" content={res?.meta_description} />
          <meta name="keywords" content={res?.meta_keywords} />
          <meta name="title" content={res?.meta_title} /> */}
          <meta property="og:title" content="CNC Machine :: FAQ"/>

        </Helmet>
    {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
      <section className="aboutcontainer">
      <div className="container">
        <div className="abbtex2" id="section1">
            
        <h2>Frequently Asked <span>Questions</span></h2>
               {faq&&faq.map((item,idx)=>{
               return <Accordion key={idx} id={id} setId={setId} idx={idx} question={item.question} answer={item.answer}/>
               })}
        </div>  
      </div>
    </section>
      
      }
    </>
  )
}

export default Faq